import React, { useState } from 'react';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import Modal from 'react-responsive-modal';
import '../sass/modalExport.css';
import 'react-day-picker/lib/style.css';
import MomentLocaleUtils, {
	formatDate,
	parseDate,
} from 'react-day-picker/moment';
import { I18n } from 'react-redux-i18n';
import moment from 'moment';
import 'moment/locale/fr';
import Button from '@material-ui/core/Button';
import CloseModal from '../svg/CloseModal';
import getDataScript from '../../../utils/getDataScript';

moment.locale('fr');

// Downloads the customer-account history over a date range by opening the signed
// data.laddition.com export URL (CustomerAccounts.php), the same signing mechanism
// as the v4 sales-analysis exports. Only db + dates + signature are needed.
function ModalDownloadHistory({ openModal, companies, onClose }) {
	const availableCompanies = Array.isArray(companies) ? companies : [];

	const [startDate, setStartDate] = useState(
		moment().startOf('month').format('YYYYMMDD')
	);
	const [endDate, setEndDate] = useState(moment().format('YYYYMMDD'));
	const [selectedDb, setSelectedDb] = useState(
		availableCompanies.length ? availableCompanies[0].company_db_name : ''
	);
	const [errorMessage, setErrorMessage] = useState('');

	const _areDatesValids = (start_Date, end_Date) => {
		if (!start_Date || !end_Date) return false;
		if (!moment(end_Date).isSameOrAfter(moment(start_Date))) {
			setErrorMessage(I18n.t('fisc.modalFisc.exportErrorReversedDates'));
			return false;
		}
		setErrorMessage('');
		return true;
	};

	const _handleStartDayChange = day => {
		if (!day) return;
		setStartDate(moment(day).format('YYYYMMDD'));
		setErrorMessage('');
	};
	const _handleEndDayChange = day => {
		if (!day) return;
		setEndDate(moment(day).format('YYYYMMDD'));
		setErrorMessage('');
	};

	const download = e => {
		e.preventDefault();
		if (!selectedDb) {
			setErrorMessage(I18n.t('customerAccount.downloadHistoryNoCompany'));
			return;
		}
		if (!_areDatesValids(startDate, endDate)) return;

		const url = getDataScript(
			'CustomerAccounts.php',
			selectedDb,
			moment(startDate).format('YYYY-MM-DD'),
			moment(endDate).format('YYYY-MM-DD')
		);
		window.open(url, '_blank');
		onClose();
	};

	const isMultiCompany = availableCompanies.length > 1;

	return (
		<div>
			<Modal
				classNames={{
					modal: 'export_modal download_history_modal',
					overlay: 'modal_export_overlay',
				}}
				open={openModal}
				showCloseIcon={false}
				onClose={onClose}
				closeOnOverlayClick={true}>
				<div className="export_modal_content">
					<div className="close_icon" onClick={onClose}>
						<CloseModal />
					</div>
					<h3>{I18n.t('customerAccount.downloadHistory')}</h3>
					<div className="export_modal_main">
						{isMultiCompany && (
							<div className="download_history_company">
								<p>{I18n.t('customerAccount.companyName')}</p>
								<select
									value={selectedDb}
									onChange={e => setSelectedDb(e.target.value)}>
									{availableCompanies.map(company => (
										<option
											key={company.company_db_name}
											value={company.company_db_name}>
											{company.company_name}
										</option>
									))}
								</select>
							</div>
						)}
						<div className="input_container">
							<div className="input_main">
								<p>{I18n.t('fisc.modalFisc.begin')} </p>
								<DayPickerInput
									local="fr"
									value={`${formatDate(startDate, 'L', 'fr')}`}
									formatDate={formatDate}
									parseDate={parseDate}
									placeholder={`${formatDate(startDate, 'L', 'fr')}`}
									onDayChange={_handleStartDayChange}
									dayPickerProps={{
										locale: 'fr',
										localeUtils: MomentLocaleUtils,
										modifiers: {},
									}}
								/>
							</div>
							<div className="input_main">
								<p>{I18n.t('fisc.modalFisc.end')}</p>
								<DayPickerInput
									local="fr"
									formatDate={formatDate}
									parseDate={parseDate}
									value={`${formatDate(endDate, 'L', 'fr')}`}
									placeholder={`${formatDate(endDate, 'L', 'fr')}`}
									onDayChange={_handleEndDayChange}
									dayPickerProps={{
										locale: 'fr',
										localeUtils: MomentLocaleUtils,
										modifiers: {},
									}}
								/>
							</div>
						</div>
						<div className="error-export">
							<p>{errorMessage}</p>
						</div>
					</div>
					<div className="modal_btn_export">
						<Button
							classes={{ root: 'btn-export first_btn' }}
							id="first_btn"
							onClick={download}>
							{I18n.t('customerAccount.downloadHistory')}
						</Button>
					</div>
				</div>
			</Modal>
		</div>
	);
}

export default ModalDownloadHistory;
